module.exports = __webpack_public_path__ + "static/hood-banner-76a16eae9be73ddceae6d8f605814864.jpeg";